(() => {
	const setPerRow = (value) => {
		document.querySelectorAll('.per-row__button').forEach(b => b.classList.remove('active'));
		document.querySelectorAll(`[data-per-row="${value}"]`).forEach(b => b.classList.add('active'));
		document.querySelectorAll('[data-productis-in-row]').forEach(grid => {
			grid.dataset.productisInRow = value;
		});
	};

	const getMobileDefault = () => {
		const list = document.querySelector('.collection-product-list');
		return list && list.classList.contains('collection-product-list--2-mobile') ? 'two' : 'one';
	};

	const init = () => {
		const liquidActiveBtn = document.querySelector('.per-row__button.active');
		const desktopDefault = liquidActiveBtn ? liquidActiveBtn.dataset.perRow : 'four';

		setPerRow(window.matchMedia('(max-width: 575px)').matches ? getMobileDefault() : desktopDefault);

		document.querySelectorAll('.per-row__button').forEach(btn => {
			btn.addEventListener('click', () => setPerRow(btn.dataset.perRow));
		});

		const mq = window.matchMedia('(max-width: 575px)');
		mq.addEventListener('change', (e) => {
			setPerRow(e.matches ? getMobileDefault() : desktopDefault);
		});
	};

	document.addEventListener('shopify:section:load', init);
	init();
})();
